import React, { useState, useEffect, useRef } from 'react'
import { userMockData, answerMockData, QuestionMockData, categoryMock } from './mock'
import axios from 'axios';
import LoadingOverlay from 'react-loading-overlay';
import ReactHtmlParser from "react-html-parser";

declare global {
  interface Window { AjaxZip3: any; }
}

const Index = (props) => {
  const { interview_key } = props;

  interface HTMLInputEvent<T extends HTMLElement> extends Event {
    target: T;
  }
　
  const icon =  require("../../../images/hearing_icon.png");
  const humanImge =  require("../../../images/body_blank_figure_front.png");
  const thankyouImg =  require("../../../images/ojigi_nurse_man.png");
  const yakkyoku_guide_thumb =  require("../../../images/yakkyoku_guide_thumb.png");

  // ユーザー情報
  const [users, setUsers] = useState<any>(userMockData);
  const [currentUser, setCurrentUser] = useState(users[0]);
  const [currentUserId, setCurrentUserId] = useState<number>(1);

  // 回答情報
  const [answerList, setAnswerList] = useState<any>(answerMockData);
  const [currentAnswerList, setCurrentAnswerList] = useState(answerMockData[0]);
  const [isAllRequiredAlreadyAnswered, setIsAllRequiredAlreadyAnswered] = useState<boolean>(false);
  const [isAutocomplete, setIsAutocomplete] = useState(true);

  // 質問情報
  const [interviewContents, setInterviewContents] = useState<any>(QuestionMockData);
  const [questionList, setQuestionList] = useState<any>(interviewContents[0].interviewContents);
  const [currentQuestion, setCurrentQuestion] = useState(questionList[0]);
  const [isAnswerRequired, setIsAnswerRequired] = useState<boolean>(false);

  const [categoryList, setCategoryList] = useState(categoryMock);
  const [currentCategoryList, setCurrentCategoryList] = useState(categoryList[0]);

  // レンダリング用
  const [update, setUpdate] = useState<Boolean>(false);

  // ロード
  const [isLoading, setIsLoading]  = useState<Boolean>(true);

  // 喫煙項目Ref
  const startYearEL = useRef(null);
  const periodEl = useRef(null);
  const numberOfCigaretteEl = useRef(null);
  // スマホ用喫煙項目Ref
  const spStartYearEL = useRef(null);
  const spPeriodEl = useRef(null);
  const spNumberOfCigaretteEl = useRef(null);
  // 妊娠項目Ref(予定日入力欄)
  const expectedDateEl = useRef(null);
  // スマホ用妊娠項目Ref(予定日入力欄)
  const spExpectedDateEl = useRef(null);
  // 授乳項目Ref(月齢入力欄)
  const monthOldEl = useRef(null);
  // スマホ用授乳項目Ref(月齢入力欄)
  const spMonthOldEl = useRef(null);

  // 初回のみ実行
  useEffect(() =>{
    axios.get(
      '/api/internal/interview/get_interviews', {
        params: {
          interview_key: interview_key
        }
      })
      .then(function (response) {
        // 患者情報
        setUsers(response.data.patients);
        setCurrentUser(response.data.patients[0]);

        // ヒアリング情報
        setInterviewContents(response.data.interview_contents);

        // 回答情報
        setAnswerList(response.data.interview_answers);

        // カテゴリー情報
        setCategoryList(response.data.categories);

        // 選択変更
        setCurrentUserId(response.data.patients[0].interviewDetailId);
        setIsLoading(false);
      })
      .catch(error => {
        setIsLoading(false);
        alert(error.response.data.message);
      });

  }, []);

  // 選択中のユーザーが変更されたとき
  useEffect(() =>{
    // 選択中のユーザー情報更新
    const patient = users.find(user => user.interviewDetailId === currentUserId)
    setCurrentUser(patient);

    // 選択中のユーザのインタビュー情報更新
    const question_list = interviewContents.find(interviewContent => interviewContent.interviewDetailId == currentUserId).interviewContents;
    setQuestionList(question_list);
    setCurrentQuestion(question_list.find(question => question.questionNumber === patient.currentQuestionNumber));

    // 選択中の回答情報更新
    setCurrentAnswerList(answerList.find(answer => answer.interviewDetailId === currentUserId));
    // 患者のカテゴリ情報
    setCurrentCategoryList(categoryList.find(category => category.interviewDetailId === currentUserId));

  },[currentUserId])

  useEffect(() =>{
    // 質問情報の更新
    setCurrentQuestion(questionList.find(question => question.questionNumber === currentUser.currentQuestionNumber));
    setIsAutocomplete(true);
  },[questionList])

  useEffect(() =>{
    // 必須項目があるかどうか？
    setIsAnswerRequired(currentQuestion.parts.some(v => v.isAnswerRequired == true));
  },[currentQuestion])

  // アンケートの最終画面確認
  useEffect(() =>{
    // 確認画面の場合(true)
    setIsAllRequiredAlreadyAnswered(false)
    if(currentAnswerList.isComplete){
      checkAllAnswerRequired() && setIsAllRequiredAlreadyAnswered(true);
    }
  },[currentAnswerList.isComplete]);

  // 必須項目チェック
  function checkAnswerRequired(){
    const check_list = []
    currentQuestion.parts.map((part, idx) => {
      if(part.isAnswerRequired == true ){
        if(part.formName === "img"){
          check_list.push(currentAnswerList.questions[currentQuestion.questionNumber].answers[idx].imgValue.length === 0);
        }else{
          check_list.push(currentAnswerList.questions[currentQuestion.questionNumber].answers[idx].value === "");
        }

      } else {
        check_list.push(false)
      }
    })
    return check_list.includes(true)
  }

  // 選択中の患者の必須チェック
  function checkAllAnswerRequired(){
    let result = false;
    currentAnswerList.questions.map((question) =>{
      question.answers.map((answer) =>{
        if(answer.isAnswerRequired && answer.value === "" && answer.imgValue.length === 0){
          result = true;
        }
      })
    })
    return result;
  }

  // テキストエリア更新
  function changeTextArea(value, questionNumber, idx) {
    const currentAnswerListDup = currentAnswerList;
    currentAnswerListDup.questions[questionNumber].answers[idx].value = value;
    currentAnswerListDup.questions[questionNumber].answers[idx].label = value;

    setCurrentAnswerList(currentAnswerListDup);
    setUpdate(update?false:true);
  }

  // ラジオボタン更新
  function changeRadioButton(value, questionNumber, idx, dataTypeName) {
    const currentAnswerListDup = currentAnswerList;
    const values = value.split(",");
    currentAnswerListDup.questions[questionNumber].answers[idx].value = values[0];
    currentAnswerListDup.questions[questionNumber].answers[idx].label = values[1];

    setCurrentAnswerList(currentAnswerListDup);
    switch(dataTypeName){
      case 'leftover_medicine':
        setIsLoading(true);
        axios.post(
          '/api/internal/interview/set_leftover_medicine', {
            dInterviewDetailId: currentUser.interviewDetailId,
            isLeftoverMedicine: values[0]
        })
        .then(function (response) {
          setIsLoading(false);
        })
        .catch(error => {
          setIsLoading(false);
          alert(error.response.data.message);
        });
        break;
      case 'question':
        setIsLoading(true);
        axios.post(
          '/api/internal/interview/set_question', {
            dInterviewDetailId: currentUser.interviewDetailId,
            isQuestion: values[0]
        })
        .then(function (response) {
          setIsLoading(false);
        })
        .catch(error => {
          setIsLoading(false);
          alert(error.response.data.message);
        });
        break;
    }
    setUpdate(update?false:true);
  }

  // チェックボックス更新
  function changeCheckBox(value, questionNumber, idx, options, checked_is_option_clear) {
    const currentAnswerListDup = currentAnswerList;
    const valueList = [];
    const labelList = [];
    let is_option_clear = false;
    let clear_option = 0;

    const checkBoxes = document.querySelectorAll(`input[name=checkbox_${currentQuestion.questionNumber}-${currentAnswerList.interviewDetailId}-${idx}].medical-history-checkbox`) as NodeListOf<HTMLInputElement>;

    options.map((option) =>{
      if(option.is_option_clear === true){
        is_option_clear = true;
        clear_option = option.value;
      }
    })

    if(checked_is_option_clear === true){
      // クリアが選択された場合
      const values = value.split(",");
      for (let i = 0; i < checkBoxes.length; i++) {
        if (checkBoxes[i].checked) {
          const check_box_value = checkBoxes[i].value.split(",");
          if (check_box_value[0] === values[0]){
            // チェックを外した時は値を設定しない
            if(checkBoxes[i].checked){
              valueList.push(values[0]);
              labelList.push(values[1]);
            }
          }else{
            checkBoxes[i].checked = false;
          }
        }
      }
    }else{
      for (let i = 0; i < checkBoxes.length; i++) {
        if (checkBoxes[i].checked) {
          const values = checkBoxes[i].value.split(",");
          if(values[0] === clear_option[0]){
            checkBoxes[i].checked = false;
          }else{
            valueList.push(values[0]);
            labelList.push(values[1]);
          }
        }
      }



    }
    currentAnswerListDup.questions[questionNumber].answers[idx].arrValue = valueList
    currentAnswerListDup.questions[questionNumber].answers[idx].value = valueList.join(',');
    currentAnswerListDup.questions[questionNumber].answers[idx].label = labelList.join(',');

    setCurrentAnswerList(currentAnswerListDup);
    setUpdate(update?false:true);
  }

  // インプットエリア更新
  function changeInput(value, questionNumber, idx, dataTypeName) {
    const currentAnswerListDup = currentAnswerList;
    currentAnswerListDup.questions[questionNumber].answers[idx].value = value;
    currentAnswerListDup.questions[questionNumber].answers[idx].label = value;

    setCurrentAnswerList(currentAnswerListDup);


    switch(dataTypeName){
      case "name":
        setIsLoading(true);
        const currentUserDup = currentUser;
        currentUserDup.patientName = value;
        axios.post(
          '/api/internal/interview/set_patient_name', {
            dInterviewDetailId: currentUser.interviewDetailId,
            patientName: value
        })
        .then(function (response) {
          setCurrentUser(currentUserDup);
          setUpdate(update?false:true);
          setIsLoading(false);
        })
        .catch(error => {
          alert(error.response.data.message);
          setIsLoading(false);
        });
        break;

      case "birthday":
        setIsLoading(true);
        axios.post(
          '/api/internal/interview/set_birthday', {
            dInterviewDetailId: currentUser.interviewDetailId,
            birthday: value
        })
        .then(function (response) {
          // 表示用の生年月日更新
          currentAnswerListDup.questions[questionNumber].answers[idx].label = response.data.disp_value;
          setCurrentAnswerList(currentAnswerListDup);
          setIsLoading(false);

          // 再レンダー
          setUpdate(update?false:true);
        })
        .catch(error => {
          // エラーだった場合は、値をデフォルト値に戻す
          currentAnswerListDup.questions[questionNumber].answers[idx].value = ''
          currentAnswerListDup.questions[questionNumber].answers[idx].label = ''
          setCurrentAnswerList(currentAnswerListDup);
          alert("形式:YYYY-MM-DDで入力してください");
          setIsLoading(false);
        });
        break;
    }
    setUpdate(update?false:true);
   }

  // セレクトリスト更新
  function changeSelectList(value, questionNumber, idx) {
    const values = value.split(",");
    const currentAnswerListDup = currentAnswerList;
    if(values[2] === 'true'){
      currentAnswerListDup.questions[questionNumber].answers[idx].value = ""
      currentAnswerListDup.questions[questionNumber].answers[idx].label = ""
    }else{
      currentAnswerListDup.questions[questionNumber].answers[idx].value = values[0];
      currentAnswerListDup.questions[questionNumber].answers[idx].label = values[1];
    }

    setCurrentAnswerList(currentAnswerListDup);
    setUpdate(update?false:true);
  }

  // ページ遷移用
  function changeCurrentQuestionNumber(value, isEditMode) {

    // 戻るボタン以外かつ必須項目だった場合はなにもしない
    const check_result = checkAnswerRequired();
    if(check_result && value != -1){
      return;
    }

    const currentUserDup = currentUser;
    const content = document.getElementById("contents_area");
    content.scrollTo(0,0);

    if (isEditMode) {
      // 編集モード（確認画面から）
      currentUserDup.currentQuestionNumber = value;

      const currentAnswerListDup = currentAnswerList;
      currentAnswerListDup.isComplete = false;
      currentAnswerListDup.isEditMode = true;

      setCurrentAnswerList(currentAnswerListDup);
      setCurrentUser(currentUserDup);

      setCurrentQuestion(questionList.find(question => question.questionNumber === currentUser.currentQuestionNumber));

      // 再レンダー
      setUpdate(update?false:true);

    } else {
      currentUserDup.currentQuestionNumber = currentUserDup.currentQuestionNumber + value;


      if(questionList.length >= currentUser.currentQuestionNumber + value){
        setCurrentUser(currentUserDup);
        setCurrentQuestion(questionList.find(question => question.questionNumber === currentUser.currentQuestionNumber));
      }else{
        // 質問数を越えたら、確認ページへ
        const currentAnswerListDup = currentAnswerList;
        currentAnswerListDup.isComplete = true;
        currentAnswerListDup.isEditMode = false;

        // ページ数が患者によって異なるため初期値へ戻す
        currentUserDup.currentQuestionNumber = 0;

        setCurrentAnswerList(currentAnswerListDup);
        setCurrentUser(currentUserDup);
        // 再レンダー
        setUpdate(update?false:true);
     }
    }
  }


  // 登録処理
  function submitInterview() {

    if(checkAllAnswerRequired()){
      alert("未入力の必須質問があります")
      return
    }
    setIsLoading(true);
    axios.post(
      '/api/internal/interview/set_interview_answers', {
        patient: currentUser,
        interview_answers: currentAnswerList
      })
      .then(function (response) {
        const currentAnswerListDup = currentAnswerList;
        currentAnswerListDup.isRegistered = true;
        setCurrentAnswerList(currentAnswerListDup);


        // 残りのユーザーがいるか確認
        let is_unanswerd = false as boolean;
        let next_patient_id = 0;
        answerList.map((answer) => {
          if(answer.interviewDetailId !=  currentUserId && answer.isRegistered === false) {
            // 未対応のユーザーかつ選択中のユーザーではない
            next_patient_id = answer.interviewDetailId;
            is_unanswerd = true;
          }
        });
        // 未回答の患者に切り替える
        (is_unanswerd) && setCurrentUserId(next_patient_id);
        // selectタブタブ
        setIsLoading(false);
        // 再レンダー
        setUpdate(update?false:true);
      })
      .catch(error => {
        setIsLoading(false);
        alert(error.response.data.message);
      });
  }

  window.AjaxZip3.onSuccess = function() {
    const currentAnswerListDup = currentAnswerList;
    const address1 = document.getElementById('address1') as HTMLInputElement;
    currentAnswerListDup.questions[currentQuestion.questionNumber].answers[1].value = address1.value;
    currentAnswerListDup.questions[currentQuestion.questionNumber].answers[1].label = address1.value;
    setCurrentAnswerList(currentAnswerListDup);
  }

  function findPatient(interviewDetailId) {
    const question_list = interviewContents.find(interviewContent => interviewContent.interviewDetailId == interviewDetailId);
    const interview_length = question_list === undefined ? 0 : question_list.interviewContents.length;
    return interview_length
  }

  function findComplete(interviewDetailId) {
    const answer_list = answerList.find(answer => answer.interviewDetailId === interviewDetailId);
    const is_complate = answer_list === undefined ? false : answer_list.isComplete
    return is_complate
  }

  // 郵便番号や電話番号を半角に直す
  function convertToHankaku (str) {
    if (!str) return ''; // 偽であれば空文字を返す

    var hankaku_eisu = function(str) {
      if (!str) return '';
      return String.fromCharCode(str.charCodeAt(0) - 0xFEE0);
    };

    str = str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, hankaku_eisu); // 英数
    str = str.replace(/[−―‐ー-－-]/g, ''); // ハイフンを削除
    return str;
  }

  // 数値入力欄を空にする（別の選択肢が選択された時やアラートが出た時など）
  function initializeInput(choice) {
    switch (choice) {
      case "notSmoke":
        // 「吸わない」を選択 → 喫煙項目の全ての数値入力欄とステートを空にする
        startYearEL.current.value = "";
        periodEl.current.value = "";
        numberOfCigaretteEl.current.value = "";
        spStartYearEL.current.value = "";
        spPeriodEl.current.value = "";
        spNumberOfCigaretteEl.current.value = "";
        currentAnswerList.questions[currentQuestion.questionNumber].answers[1].value = "";
        currentAnswerList.questions[currentQuestion.questionNumber].answers[1].label = "";
        currentAnswerList.questions[currentQuestion.questionNumber].answers[2].value = "";
        currentAnswerList.questions[currentQuestion.questionNumber].answers[2].label = "";
        currentAnswerList.questions[currentQuestion.questionNumber].answers[3].value = "";
        currentAnswerList.questions[currentQuestion.questionNumber].answers[3].label = "";
        break;
      case "stopSmoking":
        // 「禁煙した」を選択 → 「吸う」に関連する数値入力欄とステートを空にする
        numberOfCigaretteEl.current.value = "";
        spNumberOfCigaretteEl.current.value = "";
        currentAnswerList.questions[currentQuestion.questionNumber].answers[3].value = "";
        currentAnswerList.questions[currentQuestion.questionNumber].answers[3].label = "";
        break;
      case "smokingNow":
        // 「吸う」を選択 → 「禁煙した」に関連する数値入力欄とステートを空にする
        startYearEL.current.value = "";
        periodEl.current.value = "";
        spStartYearEL.current.value = "";
        spPeriodEl.current.value = "";
        currentAnswerList.questions[currentQuestion.questionNumber].answers[1].value = "";
        currentAnswerList.questions[currentQuestion.questionNumber].answers[1].label = "";
        currentAnswerList.questions[currentQuestion.questionNumber].answers[2].value = "";
        currentAnswerList.questions[currentQuestion.questionNumber].answers[2].label = "";
        break;
      case "alertStartYearEl":
        // 禁煙開始時期入力欄で範囲外の数値が入力された時
        startYearEL.current.value = "";
        spStartYearEL.current.value = "";
        currentAnswerList.questions[currentQuestion.questionNumber].answers[1].value = "";
        currentAnswerList.questions[currentQuestion.questionNumber].answers[1].label = "";
        break;
      case "alertperiodEl":
        // 期間入力欄で範囲外の数値が入力された時
        periodEl.current.value = "";
        spPeriodEl.current.value = "";
        currentAnswerList.questions[currentQuestion.questionNumber].answers[2].value = "";
        currentAnswerList.questions[currentQuestion.questionNumber].answers[2].label = "";
        break;
      case "alertnumberOfCigaretteEl":
        // 本数入力欄で範囲外の数値が入力された時
        numberOfCigaretteEl.current.value = "";
        spNumberOfCigaretteEl.current.value = "";
        currentAnswerList.questions[currentQuestion.questionNumber].answers[3].value = "";
        currentAnswerList.questions[currentQuestion.questionNumber].answers[3].label = "";
        break;
      case "notPregnant":
        // 妊娠項目で「いいえ」「可能性あり」を選択 → 予定日の入力内容を削除
        expectedDateEl.current.value = "";
        spExpectedDateEl.current.value = "";
        currentAnswerList.questions[currentQuestion.questionNumber].answers[1].value = "";
        currentAnswerList.questions[currentQuestion.questionNumber].answers[1].label = "";
        break;
      case "notFeeding":
      case "alertmonthOldEl":
        // 授乳項目で「いいえ」を選択、月齢入力欄で範囲外の数値が入力された時 → 月齢の入力内容を削除
        monthOldEl.current.value = "";
        spMonthOldEl.current.value = "";
        currentAnswerList.questions[currentQuestion.questionNumber].answers[1].value = "";
        currentAnswerList.questions[currentQuestion.questionNumber].answers[1].label = "";
    }
  }

  function alertInput(e, i, specialPartElement, type) {
    switch(type) {
      // input number型は上限下限値のチェックを行う
      case "number":
        const min = currentQuestion.parts[i].validateValueMin;
        const max = currentQuestion.parts[i].validateValueMax;

        // 最小値判定
        min != null
          ? (e.target.value < min ? ( alert("入力された数値が範囲外です。"),
                                      specialPartElement === "notSpecialPartField"
                                        ? e.target.value = ""
                                        : initializeInput(specialPartElement)
                                    )
                                  : "" )
          : ""

        // 最大値判定
        max != null
          ? (e.target.value > max ? ( alert("入力された数値が範囲外です。"),
                                      specialPartElement === "notSpecialPartField"
                                        ? e.target.value = ""
                                        : initializeInput(specialPartElement)
                                    )
                                  : "" )
          : ""
        break;
      case "tel":
        // input tel型の場合、半角数字以外はアラートを出して現在の入力内容を削除する
        e.target.value.match(/^\d+$/) ? ""
                                      : (alert("半角数字以外の文字は使用できません。"),
                                         e.target.value = "")
    }
  }

  // 画像アップロード
  function addFileInput(questionNumber, idx) {
    const upload_button = document.getElementById("upload_inteview_photo");
    if(currentAnswerList.questions[questionNumber].answers[idx].imgValue.length >= 5){
      return;
    }else{
      upload_button.click();
    }
  }

  // 画像の削除処理
  const onRemove = (question_number, idx, file_name) => {
    const currentAnswerListDup = currentAnswerList;
    currentAnswerListDup.questions[question_number].answers[idx].imgValue.map((img, i)=>{
      img.fileName === file_name && currentAnswerListDup.questions[question_number].answers[idx].imgValue.splice(i,1)
    })
    setCurrentAnswerList(currentAnswerListDup);
    setUpdate(update?false:true);
  }

  const onChangeInputFile = (e, questionNumber, idx) => {
    const currentAnswerListDup = currentAnswerList;

    if (e.target.value) {
      const file_type = e.target.files[0].type;
      const file_name = e.target.files[0].name;
      // 拡張子のチェック
      if (!file_type.includes("image/")){
        alert("画像ファイルを添付してください。");
        return;
      }

      const reader = new FileReader();
      reader.onload = function (e) {
          const image_value = { fileType: file_type, fileName: file_name, imgPath: `${e.target.result}` }
          currentAnswerListDup.questions[questionNumber].answers[idx].imgValue.push(image_value);
          setCurrentAnswerList(currentAnswerListDup);
          setUpdate(update?false:true);
      }
      reader.readAsDataURL(e.target.files[0]);
    }
  }
  // 日付変更
  // 本当はuseEffectで行いたいがいい方法が見つからず
  function changeDate(target){
    // 年が入力されたタイミング
    if (isAutocomplete && target.value.match(/^[0-9]{4}$/)) {
      target.value = target.value + "-";
      setIsAutocomplete(false);
    }

    // 月が入力されたタイミング
    if (isAutocomplete && target.value.match(/^[0-9]{4}-[0-9]{2}$/)) {
      target.value = target.value + "-";
      setIsAutocomplete(false);
    }

    // 年または月の入力が完了しそうなタイミング
    if (
      target.value.match(/^[0-9]{3}$/) ||
      target.value.match(/^[0-9]{4}-[0-9]{1}$/)
    ) {
      setIsAutocomplete(true);
    }

    // 補完直後
    if (
      target.value.match(/^[0-9]{4}-$/) ||
      target.value.match(/^[0-9]{4}-[0-9]{2}\/$/)
    ) {
      setIsAutocomplete(false);
    }
  }


  // part表示
  function partView(part, idx){
    switch(part.formName){
      case 'radio':
        {/* ラジオボタン */}
        return(
          <>
            <div className="col-md-12 col-sm-12 col-xs-12 text-left">
              <label className="interview-input-label">※どれかひとつ選択してください。</label>
            </div>
            <div className="col-md-12 col-sm-12 col-xs-12 text-left">
              <label className="interview-input-label">{ part.displayName }</label>
              {part.isAnswerRequired && <span className="label label-danger ml5">必須</span>}
            </div>
            <div className="text-center row">
              {part.options.map((option, count) => {
                return(
                  <div className="col-md-6 col-sm-12 col-xs-12">
                    <input
                      key={currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId + "-" + idx + "-" + count}
                      type="radio"
                      name={"optradio" + currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId +  "-" + idx}
                      className="display-none interview-radio"
                      id={"radio_" + currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId +  "-" + idx + "-" + count}
                      value={[option.value, option.label]}
                      defaultChecked={currentAnswerList.questions[currentQuestion.questionNumber].answers[idx].value === option.value }
                      onChange={(e) => changeRadioButton(e.target.value, currentQuestion.questionNumber, idx, part.dataTypeName)}
                    />
                    <label htmlFor={"radio_" + currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId +  "-" + idx + "-" + count} className="radio-button">{option.label}</label>
                  </div>

                )
              })}
            </div>
            <div className="interview-font-color col-md-12 col-sm-12 col-xs-12">
              {part.description}
            </div>
          </>
        )
      case 'textarea':
        {/* テキストエリア */}
        return(
          <>
            <div className="col-md-12 col-sm-12 col-xs-12 text-left padding0">
              <label className="interview-input-label">{ part.displayName }</label>
              {part.isAnswerRequired && <span className="label label-danger ml5">必須</span>}
            </div>
            <div className="text-center row">
              <div className="col-md-12 col-sm-12 col-xs-12">
                <textarea
                  key={currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId + "-" + idx}
                  className="form-control text-area-width"
                  id={"comment_" + currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId +  "-" + idx}
                  rows={4}
                  placeholder={part.placeholder}
                  maxLength={1000}
                  defaultValue={currentAnswerList.questions[currentQuestion.questionNumber].answers[idx].value}
                  onChange={(e) => changeTextArea(e.target.value, currentQuestion.questionNumber, idx)}
                />
              </div>
            </div>
            <div className="interview-font-color col-md-12 col-sm-12 col-xs-12">
              {part.description}
            </div>
          </>
        )
      case 'checkbox':
        {/* チェックボックス */}
        return(
          <>
            <div className="col-md-12 col-sm-12 col-xs-12 text-left">
              <label className="interview-input-label">※複数選択できます。</label>
            </div>
            <div className="col-md-12 col-sm-12 col-xs-12 text-left">
              <label className="interview-input-label">{ part.displayName }</label>
              {part.isAnswerRequired && <span className="label label-danger ml5">必須</span>}
            </div>
            <div className="text-center row" key={"checkbox_" + currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId +  "-" + idx}>
              {part.options.map((option, count) => {
                return(
                  <div className="col-md-6 col-sm-12 col-xs-12">
                    <input
                      key={currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId + "-" + idx}
                      type="checkbox"
                      name={"checkbox_" + currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId +  "-" + idx}
                      className="display-none medical-history-checkbox"
                      id={"checkbox_" + currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId +  "-" + idx + "-" + count}
                      value={[option.value, option.label]}
                      defaultChecked={currentAnswerList.questions[currentQuestion.questionNumber].answers[idx].arrValue.includes(option.value) }
                      onChange={(e) => changeCheckBox(e.target.value, currentQuestion.questionNumber, idx, part.options, option.is_option_clear)}
                    />
                    <label className="checkbox-button" htmlFor={"checkbox_" + currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId +  "-" + idx + "-" + count}>{option.label}</label>
                  </div>
                )
              })}
            </div>
            <div className="interview-font-color col-md-12 col-sm-12 col-xs-12">
              {part.description}
            </div>
          </>
        )
        case 'checkbox_img':
          {/* チェックボックス_イメージあり */}
          return(
            <>
              <div className="col-md-12 col-sm-12 col-xs-12 text-left">
                <label className="interview-input-label">※複数選択できます。</label>
                {part.isAnswerRequired && <span className="label label-danger ml5">必須</span>}
              </div>
              <div key={"checkbox_" + currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId +  "-" + idx}>
                <div className="row row-height-flex">
                  <div className="text-center col-xs-12 d-none">
                    <img src={humanImge} className="human-img" alt="アイコン"></img>
                  </div>
                  <div className="col-md-4 col-sm-12 col-xs-12 margin-auto">
                    {part.options.map((option, count) => {
                      return(
                        <>
                        { count % 2 === 0 && (
                          <>
                            <input
                              key={currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId + "-" + idx}
                              type="checkbox"
                              className="display-none medical-history-checkbox"
                              id={"checkbox_" + currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId +  "-" + idx + "-" + count}
                              name={"checkbox_" + currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId +  "-" + idx}
                              value={[option.value, option.label]}
                              defaultChecked={currentAnswerList.questions[currentQuestion.questionNumber].answers[idx].arrValue.includes(option.value) }
                              onChange={(e) => changeCheckBox(e.target.value, currentQuestion.questionNumber, idx, part.options, option.is_option_clear)}
                            />
                            <label className="checkbox-button" htmlFor={"checkbox_" + currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId +  "-" + idx + "-" + count}>{option.label}</label>
                          </>
                          )}
                        </>
                      )
                    })}
                  </div>
                  <div className="col-md-4 d-xs-none text-center">
                    <img src={humanImge} className="human-img" alt="アイコン"></img>
                  </div>
                  <div className="col-md-4 col-sm-12 col-xs-12 margin-auto">
                    {part.options.map((option, count) => {
                      return(
                        <>
                          { count % 2 === 1 && (
                            <>
                              <input
                                key={currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId + "-" + idx}
                                type="checkbox"
                                className="display-none medical-history-checkbox"
                                id={"checkbox_" + currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId +  "-" + idx + "-" + count}
                                name={"checkbox_" + currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId +  "-" + idx}
                                value={[option.value, option.label]}
                                defaultChecked={currentAnswerList.questions[currentQuestion.questionNumber].answers[idx].value.includes(option.value) }
                                onChange={(e) => changeCheckBox(e.target.value, currentQuestion.questionNumber, idx, part.options, option.is_option_clear)}
                              />
                              <label className="checkbox-button" htmlFor={"checkbox_" + currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId +  "-" + idx + "-" + count}>{option.label}</label>
                            </>
                          )}
                        </>
                    )
                    })}
                  </div>
                </div>
              </div>
            </>
          )
        // インプット（文字列）
        case 'input':
          return(
            <>
              <div className="col-md-12 col-sm-12 col-xs-12 text-left">
                  <label className="interview-input-label">{ part.displayName }</label>
                  {part.isAnswerRequired && <span className="label label-danger ml5">必須</span>}
              </div>

              <div className="text-center row">
                <div className="col-md-3 d-xs-none text-right">
                    <label className="interview-input-label">{ part.displayLeft }</label>
                </div>
                <div className="text-left col-xs-12 d-none">
                  <label className="interview-input-label">{ part.displayLeft }</label>
                </div>
                <div className="form-group col-md-6 col-sm-12 col-xs-12">
                  <input
                    key={currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId + "-" + idx}
                    type="text"
                    className="form-control"
                    autoComplete="off"
                    maxLength={255}
                    defaultValue={currentAnswerList.questions[currentQuestion.questionNumber].answers[idx].value === "" ? part.fieldDefaultValue : currentAnswerList.questions[currentQuestion.questionNumber].answers[idx].value}
                    placeholder={part.placeholder}
                    onBlur={(e) => changeInput(e.target.value, currentQuestion.questionNumber, idx, part.dataTypeName)}
                  />
                </div>
                <div className="col-md-3 d-xs-none text-left">
                  <label className="interview-input-label">{ part.displayRight}</label>
                </div>
                <div className="text-right col-xs-12 d-none">
                  <label className="interview-input-label">{ part.displayRight}</label>
                </div>
              </div>
            </>
          )
          // インプット（数値）
          case 'input_integer':
            return(
              <div className="row interview-input-form">
                <div className="col-md-12 col-sm-12 col-xs-12 text-left">
                  <label className="interview-input-label">{ part.displayName }</label>
                  {part.isAnswerRequired && <span className="label label-danger ml5">必須</span>}
                </div>
                <div className="col-md-3 d-xs-none text-right">
                    <label className="interview-input-label">{ part.displayLeft }</label>
                </div>
                <div className="text-left col-xs-12 d-none">
                  <label className="interview-input-label">{ part.displayLeft }</label>
                </div>
                <div className="col-md-6 col-sm-12 col-xs-12">
                  <input
                    key={currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId + "-" + idx}
                    type="number"
                    id={"input_" + currentQuestion.questionNumber + "_" + currentAnswerList.interviewDetailId + "_" + idx}
                    className="form-control"
                    autoComplete="off"
                    // onChange={(e) => sliceMaxLength(e, 9, "number")}
                    defaultValue={currentAnswerList.questions[currentQuestion.questionNumber].answers[idx].value === "" ? part.fieldDefaultValue : currentAnswerList.questions[currentQuestion.questionNumber].answers[idx].value}
                    placeholder={part.placeholder}
                    onBlur={(e) => {
                      !(!e.target.value) ? alertInput(e, idx, "notSpecialPartField", "number") : ""
                      changeInput(e.target.value, currentQuestion.questionNumber, idx, part.dataTypeName)}}
                  />
                </div>
                <div className="col-md-3 d-xs-none text-left">
                  <label className="interview-input-label">{ part.displayRight}</label>
                </div>
                <div className="text-right col-xs-12 d-none">
                  <label className="interview-input-label">{ part.displayRight}</label>
                </div>
              </div>
            )
          // インプット（小数点）
          case 'input_decimal':
            return(
              <div className="row interview-input-form">
                <div className="col-md-12 col-sm-12 col-xs-12 text-left">
                  <label className="interview-input-label">{ part.displayName }</label>
                  {part.isAnswerRequired && <span className="label label-danger ml5">必須</span>}
                </div>
                <div className="col-md-3 col-sm-12 d-xs-none text-right">
                    <label className="interview-input-label">{ part.displayLeft }</label>
                </div>
                <div className="text-left col-xs-12 d-none">
                  <label className="interview-input-label">{ part.displayLeft }</label>
                </div>
                <div className="col-md-6 col-sm-12 col-xs-12">
                  <input
                    key={currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId + "-" + idx}
                    type="number"
                    id={"input_" + currentQuestion.questionNumber + "_" + currentAnswerList.interviewDetailId + "_" + idx}
                    className="form-control"
                    autoComplete="off"
                    // onChange={(e) => sliceMaxLength(e, 9, "decimal")}
                    defaultValue={currentAnswerList.questions[currentQuestion.questionNumber].answers[idx].value === "" ? part.fieldDefaultValue : currentAnswerList.questions[currentQuestion.questionNumber].answers[idx].value}
                    placeholder={part.placeholder}
                    onBlur={(e) => {
                      !(!e.target.value) ? alertInput(e, idx, "notSpecialPartField", "number") : ""
                      changeInput(e.target.value, currentQuestion.questionNumber, idx, part.dataTypeName)
                    }}
                  />
                </div>
                <div className="col-md-3 d-xs-none text-left">
                  <label className="interview-input-label">{ part.displayRight}</label>
                </div>
                <div className="text-right col-xs-12 d-none">
                  <label className="interview-input-label">{ part.displayRight}</label>
                </div>
              </div>
            )
          // セレクトリスト
          case 'select_list':
            return(
              <div className="from-group">
                <label className="interview-input-label" htmlFor={"select_list_" + currentQuestion.questionNumber + "_" + currentAnswerList.interviewDetailId +  "_" + idx}>{part.displayName}</label>
                {part.isAnswerRequired && <span className="label label-danger ml5">必須</span>}
                <div className="row">
                  <div className="col-md-3 d-xs-none text-right">
                    <label className="interview-input-label">{ part.displayLeft }</label>
                  </div>
                  <div className="text-left col-xs-12 d-none">
                    <label className="interview-input-label">{ part.displayLeft }</label>
                  </div>
                  <div className="col-md-6 col-sm-12 col-xs-12">
                    <select
                      className="form-control interview-input-label"
                      id={"select_list_" + currentQuestion.questionNumber + "_" + currentAnswerList.interviewDetailId +  "_" + idx}
                      onChange={(e) => changeSelectList(e.target.value, currentQuestion.questionNumber, idx)}
                    >
                      <option value=""> 回答を選択してください </option>
                      {part.options.map((option) => {
                        return(
                          <>
                            {
                              currentAnswerList.questions[currentQuestion.questionNumber].answers[idx].value === option.value ?
                                (
                                  <option value={[option.value, option.label, option.is_option_clear]} selected> {option.label} </option>
                                ):(
                                  <option value={[option.value, option.label, option.is_option_clear]}> {option.label} </option>

                                )
                            }
                          </>
                        )
                      })}
                    </select>
                  </div>
                  <div className="col-md-3 col-sm-12 col-xs-12 text-left">
                    <label className="interview-input-label">{ part.displayRight }</label>
                  </div>
                </div>
                <div className="interview-font-color col-md-12 col-sm-12 col-xs-12">
                  {part.description}
                </div>
              </div>
            )
          // 日付
          case 'date':
            return(
              <>
                <div className="col-md-12 col-sm-12 col-xs-12 text-left">
                    <label className="interview-input-label">{ part.displayName }</label>
                    {part.isAnswerRequired && <span className="label label-danger ml5">必須</span>}
                </div>

                <div className="text-center row">
                  <div className="col-md-3 d-xs-none text-right">
                      <label className="interview-input-label">{ part.displayLeft }</label>
                  </div>
                  <div className="text-left col-xs-12 d-none">
                    <label className="interview-input-label">{ part.displayLeft }</label>
                  </div>
                  <div className="form-group col-md-6 col-sm-12 col-xs-12">
                    <input
                      key={currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId + "-" + idx}
                      type="tel"
                      className="form-control"
                      autoComplete="off"
                      maxLength={10}
                      defaultValue={currentAnswerList.questions[currentQuestion.questionNumber].answers[idx].value === "" ? part.fieldDefaultValue : currentAnswerList.questions[currentQuestion.questionNumber].answers[idx].value}
                      placeholder={part.placeholder}
                      // value={dateValue}
                      onChange={(e) => changeDate(e.target)}
                      onBlur={(e) => changeInput(e.target.value, currentQuestion.questionNumber, idx, part.dataTypeName)}
                      pattern="^[0-9]{4}\/[0-9]{2}\/[0-9]{2}$"
                      title="YYYY-MM-DD形式で入力してください"
                    />
                  </div>
                  <div className="col-md-3 d-xs-none text-left">
                    <label className="interview-input-label">{ part.displayRight}</label>
                  </div>
                  <div className="text-right col-xs-12 d-none">
                    <label className="interview-input-label">{ part.displayRight}</label>
                  </div>
                  <br/>
                  <div className="col-md-12 col-sm-12 col-xs-12">
                    <label className="interview-input-label">(例) 1985-01-01 ※「-」は自動で入力されます。</label>
                  </div>
                </div>
              </>
            )
          case 'input_phone':
            return(
              <div className="row interview-input-form">
                <div className="col-md-12 col-sm-12 col-xs-12 text-left">
                  <label className="interview-input-label">{ part.displayName }</label>
                  {part.isAnswerRequired && <span className="label label-danger ml5">必須</span>}
                </div>
                <div className="col-md-3 d-xs-none text-right">
                    <label className="interview-input-label">{ part.displayLeft }</label>
                </div>
                <div className="text-left col-xs-12 d-none">
                  <label className="interview-input-label">{ part.displayLeft }</label>
                </div>
                <div className="col-md-6 col-sm-12 col-xs-12">
                  <input
                    key={currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId + "-" + idx}
                    type="tel"
                    id={"input_" + currentQuestion.questionNumber + "_" + currentAnswerList.interviewDetailId + "_" + idx}
                    className="form-control"
                    autoComplete="off"
                    maxLength={13}
                    defaultValue={currentAnswerList.questions[currentQuestion.questionNumber].answers[idx].value === "" ? part.fieldDefaultValue : currentAnswerList.questions[currentQuestion.questionNumber].answers[idx].value}
                    placeholder={part.placeholder}
                    onBlur={(e) => {
                      !(!e.target.value) ? (e.target.value = convertToHankaku(e.target.value),
                                            alertInput(e, idx, "notSpecialPartField", "tel"))
                                         : ""
                      changeInput(e.target.value, currentQuestion.questionNumber, idx, part.dataTypeName);
                    }}
                  />
                </div>
                <div className="col-md-3 d-xs-none text-left">
                  <label className="interview-input-label">{ part.displayRight}</label>
                </div>
                <div className="text-right col-xs-12 d-none">
                  <label className="interview-input-label">{ part.displayRight}</label>
                </div>
              </div>
            )
          // 画像
          case 'img':
            return(
              <>
                <div className="col-md-12 col-sm-12 col-xs-12 text-left">
                  <label className="interview-input-label">{ part.displayName }</label>
                  {part.isAnswerRequired && <span className="label label-danger ml5">必須</span>}
                </div>
                <div className="col-md-12 col-sm-12 col-xs-12 text-right">
                  {
                  <button className="btn btn-interview add-prescription-btn" disabled={currentAnswerList.questions[currentQuestion.questionNumber].answers[idx].imgValue.length >= 5 } onClick={() => addFileInput(currentQuestion.questionNumber, idx)}>
                    <span className="glyphicon glyphicon-camera mr10" aria-hidden="true"></span>
                    写真を撮る（ファイル添付）
                  </button>
                  }

                  <input
                    type="file"
                    key={currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId + "-" + idx}
                    id="upload_inteview_photo"
                    accept="image/*"
                    className="interview-file-input hidden"
                    onChange={(e) => onChangeInputFile(e,currentQuestion.questionNumber, idx)}
                  />
                  <br/>
                  <div className="well">
                    <div id="file_input_area" className="interview-img-area" >
                      {
                        currentAnswerList.questions[currentQuestion.questionNumber].answers[idx].imgValue.map((imgValue) => {
                          return(
                            <div id={`custom_${imgValue.fileName}`} className="col-md-2">
                              <span>
                                <span className="btn">
                                  <span className="glyphicon glyphicon-trash" onClick={() => onRemove(currentQuestion.questionNumber, idx, imgValue.fileName)}/>
                                </span>
                              </span>
                              <span className="preview-content">
                                <img id={`preview_${imgValue.fileName}`}
                                  className="preview-img interview-upload-file"
                                  src={imgValue.imgPath}
                                />
                              </span>
                            </div>
                          )
                        })
                      }
                    </div>
                    </div>
                  </div>
              </>
            )

      }
  }

  function specialPartView() {
    switch(currentQuestion.partKbn){
      case 4:
       // 住所テンプレート
       return(
        <>
          <div className="row interview-input-form">
            <div className="col-md-5 d-xs-none text-right">
              <label className="interview-input-label">{ currentQuestion.parts[0].displayLeft }</label>
            </div>
            <div className="text-left col-xs-12 d-none">
              <label className="interview-input-label">{ currentQuestion.parts[0].displayLeft }</label>
            </div>
            <div className="col-md-6 col-sm-12 col-xs-12">
              <input
                key={currentQuestion.questionNumber + "_" + currentAnswerList.interviewDetailId + "_" + 0}
                type="tel"
                id={"input_" + currentQuestion.questionNumber + "_" + currentAnswerList.interviewDetailId + "_" + 0}
                name="zipCode"
                className="form-control"
                autoComplete="off"
                maxLength={8}
                defaultValue={currentAnswerList.questions[currentQuestion.questionNumber].answers[0].value}
                placeholder={currentQuestion.parts[0].placeholder}
                // onChange={(e) => changeInput(e.target.value, currentQuestion.questionNumber, 0, "zipCode")}
                onBlur={(e) => {
                  !(!e.target.value) ? (e.target.value = convertToHankaku(e.target.value),
                                        alertInput(e, 0, "notSpecialPartField", "tel"))
                                     : ""
                  changeInput(e.target.value, currentQuestion.questionNumber, 0, "zipCode")
                  window.AjaxZip3.zip2addr('zipCode','','address1','address1');
                }}
              />
            </div>
          </div>
          <div className="row interview-input-form">
            <div className="col-md-5 d-xs-none text-right">
              <label className="interview-input-label">{ currentQuestion.parts[1].displayLeft }</label>
            </div>
            <div className="text-left col-xs-12 d-none">
              <label className="interview-input-label">{ currentQuestion.parts[1].displayLeft }</label>
            </div>
            <div className="col-md-6 col-sm-12 col-xs-12">
              <input
                key={currentQuestion.questionNumber + "_" + currentAnswerList.interviewDetailId + "_" + 1}
                type="text"
                id="address1"
                name="address1"
                className="form-control"
                autoComplete="off"
                maxLength={255}
                defaultValue={currentAnswerList.questions[currentQuestion.questionNumber].answers[1].value}
                placeholder={currentQuestion.parts[1].placeholder}
                onChange={(e) => changeInput(e.target.value, currentQuestion.questionNumber, 1, "address")}
              />
            </div>
          </div>

          <div className="row interview-input-form">
            <div className="col-md-5 d-xs-none text-right">
              <label className="interview-input-label">{ currentQuestion.parts[2].displayLeft }</label>
            </div>
            <div className="text-left col-xs-12 d-none">
              <label className="interview-input-label">{ currentQuestion.parts[2].displayLeft }</label>
            </div>
            <div className="col-md-6 col-sm-12 col-xs-12">
              <input
                key={currentQuestion.questionNumber + "_" + currentAnswerList.interviewDetailId + "_" + 2}
                type="text"
                id="address2"
                name="address2"
                className="form-control"
                autoComplete="off"
                maxLength={255}
                defaultValue={currentAnswerList.questions[currentQuestion.questionNumber].answers[2].value}
                placeholder={currentQuestion.parts[2].placeholder}
                onChange={(e) => changeInput(e.target.value, currentQuestion.questionNumber, 2, "address")}
              />
            </div>
          </div>
        </>
       )
      case 5:
        // 喫煙テンプレート
        return(
          <>
            {/* スマートフォン用テンプレート */}
            <div className="d-none">
              <div className="col-xs-12">
                <input
                  key={"sp_" + currentQuestion.questionNumber + "_" + currentAnswerList.interviewDetailId + "_" + 0 + "_" + 0}
                  type="radio"
                  name="optradio_sp"
                  className="display-none interview-radio"
                  id={"radio_sp_" + currentQuestion.questionNumber + "_" + currentAnswerList.interviewDetailId +  "_" + 0 + "_" + 0}
                  value={[currentQuestion.parts[0].options[0].value, currentQuestion.parts[0].options[0].label]}
                  defaultChecked={currentAnswerList.questions[currentQuestion.questionNumber].answers[0].value === currentQuestion.parts[0].options[0].value }
                  onChange={(e) => {
                    changeRadioButton(e.target.value, currentQuestion.questionNumber, 0, currentQuestion.parts[0].dataTypeName);
                    initializeInput("notSmoke");
                  }}
                />
                <label htmlFor={"radio_sp_" + currentQuestion.questionNumber + "_" + currentAnswerList.interviewDetailId +  "_" + 0 + "_" + 0} className="radio-button">{currentQuestion.parts[0].options[0].label}</label>
              </div>

              <div className="col-xs-12">
                <input
                  key={"sp_" + currentQuestion.questionNumber + "_" + currentAnswerList.interviewDetailId + "_" + 0 + "_" + 1}
                  type="radio"
                  name="optradio_sp"
                  className="display-none interview-radio"
                  id={"radio_sp_" + currentQuestion.questionNumber + "_" + currentAnswerList.interviewDetailId +  "_" + 0 + "_" + 1}
                  value={[currentQuestion.parts[0].options[1].value, currentQuestion.parts[0].options[1].label]}
                  defaultChecked={currentAnswerList.questions[currentQuestion.questionNumber].answers[0].value === currentQuestion.parts[0].options[1].value }
                  onChange={(e) => {
                    changeRadioButton(e.target.value, currentQuestion.questionNumber, 0, currentQuestion.parts[0].dataTypeName);
                    initializeInput("stopSmoking");
                  }}
                />
                <label htmlFor={"radio_sp_" + currentQuestion.questionNumber + "_" + currentAnswerList.interviewDetailId +  "_" + 0 + "_" + 1} className="radio-button">{currentQuestion.parts[0].options[1].label}</label>
              </div>

              <div className="col-xs-12">
                <div className="col-md-4 col-sm-4 text-left">
                  <label className="interview-input-label">{ currentQuestion.parts[1].displayLeft }</label>
                </div>
                <div className="col-md-5 col-sm-5 ">
                  <input
                    key={"sp_" + currentQuestion.questionNumber + "_" + currentAnswerList.interviewDetailId + "_" + 1}
                    type="number"
                    id={"input_sp_" + currentQuestion.questionNumber + "_" + currentAnswerList.interviewDetailId + "_" + 1}
                    className="form-control"
                    // onChange={(e) => sliceMaxLength(e, 9, "number")}
                    defaultValue={currentAnswerList.questions[currentQuestion.questionNumber].answers[1].value}
                    placeholder={currentQuestion.parts[1].placeholder}
                    onBlur={(e) => {
                      !(!e.target.value) ? alertInput(e, 1, "alertStartYearEl", "number") : "";
                      changeInput(e.target.value, currentQuestion.questionNumber, 1, currentQuestion.parts[1].dataTypeName);
                    }}
                    disabled={currentAnswerList.questions[currentQuestion.questionNumber].answers[0].value === currentQuestion.parts[0].options[1].value ? false : true }
                    ref={spStartYearEL}
                  />
                </div>
                <div className="col-md-3 col-sm-3 text-right">
                  <label className="interview-input-label">{ currentQuestion.parts[1].displayRight }</label>
                </div>
              </div>

              <div className="col-xs-12">
                <div className="col-md-4 col-sm-4 text-left">
                  <label className="interview-input-label">{ currentQuestion.parts[2].displayLeft }</label>
                </div>
                <div className="col-md-5 col-sm-5">
                  <input
                    key={"sp_" + currentQuestion.questionNumber + "_" + currentAnswerList.interviewDetailId + "_" + 2}
                    type="number"
                    id={"input_sp_" + currentQuestion.questionNumber + "_" + currentAnswerList.interviewDetailId + "_" + 2}
                    className="form-control"
                    // onChange={(e) => sliceMaxLength(e, 9, "number")}
                    defaultValue={currentAnswerList.questions[currentQuestion.questionNumber].answers[2].value}
                    placeholder={currentQuestion.parts[2].placeholder}
                    onBlur={(e) => {
                      !(!e.target.value) ? alertInput(e, 2, "alertperiodEl", "number") : "";
                      changeInput(e.target.value, currentQuestion.questionNumber, 2, currentQuestion.parts[1].dataTypeName)
                    }}
                    disabled={currentAnswerList.questions[currentQuestion.questionNumber].answers[0].value === currentQuestion.parts[0].options[1].value ? false : true }
                    ref={spPeriodEl}
                  />
                </div>
                <div className="col-md-3 col-sm-3  text-right">
                  <label className="interview-input-label">{ currentQuestion.parts[2].displayRight }</label>
                </div>
              </div>

              <div className="col-xs-12">
                <input
                  key={"sp_" + currentQuestion.questionNumber + "_" + currentAnswerList.interviewDetailId + "_" + 0 + "_" + 2}
                  type="radio"
                  name="optradio_sp"
                  className="display-none interview-radio"
                  id={"radio_sp_" + currentQuestion.questionNumber + "_" + currentAnswerList.interviewDetailId +  "_" + 0 + "_" + 2}
                  value={[currentQuestion.parts[0].options[2].value, currentQuestion.parts[0].options[2].label]}
                  defaultChecked={currentAnswerList.questions[currentQuestion.questionNumber].answers[0].value === currentQuestion.parts[0].options[2].value }
                  onChange={(e) => {
                    changeRadioButton(e.target.value, currentQuestion.questionNumber, 0, currentQuestion.parts[0].dataTypeName);
                    initializeInput("smokingNow");
                  }}
                />
                <label htmlFor={"radio_sp_" + currentQuestion.questionNumber + "_" + currentAnswerList.interviewDetailId +  "_" + 0 + "_" + 2} className="radio-button">{currentQuestion.parts[0].options[2].label}</label>
              </div>

              <div className="col-xs-12">
                <div className="col-md-5 col-sm-5 text-left">
                  <label className="interview-input-label">{ currentQuestion.parts[3].displayLeft }</label>
                </div>

                <div className="col-md-5 col-sm-5">
                  <input
                    key={"sp_" + currentQuestion.questionNumber + "_" + currentAnswerList.interviewDetailId + "_" + 3}
                    type="number"
                    id={"input_sp_" + currentQuestion.questionNumber + "_" + currentAnswerList.interviewDetailId + "_" + 3}
                    className="form-control"
                    // onChange={(e) => sliceMaxLength(e, 9, "number")}
                    defaultValue={currentAnswerList.questions[currentQuestion.questionNumber].answers[3].value}
                    placeholder={currentQuestion.parts[3].placeholder}
                    onBlur={(e) => {
                      !(!e.target.value) ? alertInput(e, 3, "alertnumberOfCigaretteEl", "number") : "";
                      changeInput(e.target.value, currentQuestion.questionNumber, 3, currentQuestion.parts[3].dataTypeName);
                    }}
                    disabled={currentAnswerList.questions[currentQuestion.questionNumber].answers[0].value === currentQuestion.parts[0].options[2].value ? false : true }
                    ref={spNumberOfCigaretteEl}
                  />
                </div>

                <div className="col-md-2 col-sm-2 text-right">
                  <label className="interview-input-label">{ currentQuestion.parts[3].displayRight}</label>
                </div>
              </div>

            </div>

            {/* スマホ以外 */}
            <table className="d-xs-none">
              <thead/>
              <tbody>
                <tr>
                  <td className="col-md-6 col-sm-6">
                      <input
                        key={currentQuestion.questionNumber + "_" + currentAnswerList.interviewDetailId + "_" + 0 + "_" + 0}
                        type="radio"
                        name="optradio"
                        className="display-none interview-radio"
                        id={"radio_" + currentQuestion.questionNumber + "_" + currentAnswerList.interviewDetailId +  "_" + 0 + "_" + 0}
                        value={[currentQuestion.parts[0].options[0].value, currentQuestion.parts[0].options[0].label]}
                        defaultChecked={currentAnswerList.questions[currentQuestion.questionNumber].answers[0].value === currentQuestion.parts[0].options[0].value }
                        onChange={(e) => {
                          changeRadioButton(e.target.value, currentQuestion.questionNumber, 0, currentQuestion.parts[0].dataTypeName);
                          initializeInput("notSmoke");
                        }}
                      />
                      <label htmlFor={"radio_" + currentQuestion.questionNumber + "_" + currentAnswerList.interviewDetailId +  "_" + 0 + "_" + 0} className="radio-button">{currentQuestion.parts[0].options[0].label}</label>
                  </td>
                  <td className="col-md-6 col-sm-6" />
                </tr>

                <tr>
                  <td className="col-md-6 col-sm-6">
                      <input
                        key={currentQuestion.questionNumber + "_" + currentAnswerList.interviewDetailId + "_" + 0 + "_" + 1}
                        type="radio"
                        name="optradio"
                        className="display-none interview-radio"
                        id={"radio_" + currentQuestion.questionNumber + "_" + currentAnswerList.interviewDetailId +  "_" + 0 + "_" + 1}
                        value={[currentQuestion.parts[0].options[1].value, currentQuestion.parts[0].options[1].label]}
                        defaultChecked={currentAnswerList.questions[currentQuestion.questionNumber].answers[0].value === currentQuestion.parts[0].options[1].value }
                        onChange={(e) => {
                          changeRadioButton(e.target.value, currentQuestion.questionNumber, 0, currentQuestion.parts[0].dataTypeName);
                          initializeInput("stopSmoking");
                        }}
                      />
                      <label htmlFor={"radio_" + currentQuestion.questionNumber + "_" + currentAnswerList.interviewDetailId + "_" + 0 + "_" + 1} className="radio-button">{currentQuestion.parts[0].options[1].label}</label>
                  </td>

                  <td className="col-md-6 col-sm-6 text-center">
                    <div className="row interview-input-form">
                      <div className="col-md-4 col-sm-4 text-right">
                        <label className="interview-input-label">{ currentQuestion.parts[1].displayLeft }</label>
                      </div>
                      <div className="col-md-5 col-sm-5 ">
                        <input
                          key={currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId + "-" + 1}
                          type="number"
                          id={"input_" + currentQuestion.questionNumber + "_" + currentAnswerList.interviewDetailId + "_" + 1}
                          className="form-control"
                          // onChange={(e) => sliceMaxLength(e, 9, "number")}
                          defaultValue={currentAnswerList.questions[currentQuestion.questionNumber].answers[1].value}
                          placeholder={currentQuestion.parts[1].placeholder}
                          onBlur={(e) => {
                            !(!e.target.value) ? alertInput(e, 1, "alertStartYearEl", "number") : "";
                            changeInput(e.target.value, currentQuestion.questionNumber, 1, currentQuestion.parts[1].dataTypeName);
                          }}
                          disabled={currentAnswerList.questions[currentQuestion.questionNumber].answers[0].value === currentQuestion.parts[0].options[1].value ? false : true }
                          ref={startYearEL}
                          min={currentQuestion.parts[1].validateValueMin}
                        />
                      </div>
                      <div className="col-md-3 col-sm-3 text-left">
                        <label className="interview-input-label">{ currentQuestion.parts[1].displayRight }</label>
                      </div>

                      <div className="col-md-4 col-sm-4 text-right">
                        <label className="interview-input-label">{ currentQuestion.parts[2].displayLeft }</label>
                      </div>
                      <div className="col-md-5 col-sm-5">
                        <input
                          key={currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId + "-" + 2}
                          type="number"
                          id={"input_" + currentQuestion.questionNumber + "_" + currentAnswerList.interviewDetailId + "_" + 2}
                          className="form-control"
                          // onChange={(e) => sliceMaxLength(e, 9, "number")}
                          defaultValue={currentAnswerList.questions[currentQuestion.questionNumber].answers[2].value}
                          placeholder={currentQuestion.parts[2].placeholder}
                          onBlur={(e) => {
                            !(!e.target.value) ? alertInput(e, 2, "alertperiodEl", "number") : "";
                            changeInput(e.target.value, currentQuestion.questionNumber, 2, currentQuestion.parts[1].dataTypeName);
                          }}
                          disabled={currentAnswerList.questions[currentQuestion.questionNumber].answers[0].value === currentQuestion.parts[0].options[1].value ? false : true }
                          ref={periodEl}
                          min={currentQuestion.parts[2].validateValueMin}
                          max={currentQuestion.parts[2].validateValueMax}
                        />
                      </div>
                      <div className="col-md-3 col-sm-3  text-left">
                        <label className="interview-input-label">{ currentQuestion.parts[2].displayRight }</label>
                      </div>

                    </div>

                  </td>
                </tr>
                <tr>
                  <td className="col-md-6 col-sm-6 ">
                      <input
                        key={currentQuestion.questionNumber + "_" + currentAnswerList.interviewDetailId + "_" + 0 + "_" + 2}
                        type="radio"
                        name="optradio"
                        className="display-none interview-radio"
                        id={"radio_" + currentQuestion.questionNumber + "_" + currentAnswerList.interviewDetailId +  "_" + 0 + "_" + 2}
                        value={[currentQuestion.parts[0].options[2].value, currentQuestion.parts[0].options[2].label]}
                        defaultChecked={currentAnswerList.questions[currentQuestion.questionNumber].answers[0].value === currentQuestion.parts[0].options[2].value }
                        onChange={(e) => {
                          changeRadioButton(e.target.value, currentQuestion.questionNumber, 0, currentQuestion.parts[0].dataTypeName);
                          initializeInput("smokingNow");
                        }}
                      />
                      <label htmlFor={"radio_" + currentQuestion.questionNumber + "_" + currentAnswerList.interviewDetailId +  "_" + 0 + "_" + 2} className="radio-button">{currentQuestion.parts[0].options[2].label}</label>
                  </td>
                  <td className="col-md-6 col-sm-6 text-center">
                    <div className="row interview-input-form">

                      <div className="col-md-5 col-sm-5 text-right">
                        <label className="interview-input-label">{ currentQuestion.parts[3].displayLeft }</label>
                      </div>

                      <div className="col-md-5 col-sm-5">
                        <input
                          key={currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId + "-" + 3}
                          type="number"
                          // onChange={(e) => sliceMaxLength(e, 9, "number")}
                          id={"input_" + currentQuestion.questionNumber + "_" + currentAnswerList.interviewDetailId + "_" + 3}
                          className="form-control"
                          defaultValue={currentAnswerList.questions[currentQuestion.questionNumber].answers[3].value}
                          placeholder={currentQuestion.parts[3].placeholder}
                          onBlur={(e) => {
                            !(!e.target.value) ? alertInput(e, 3, "alertnumberOfCigaretteEl", "number") : "";
                            changeInput(e.target.value, currentQuestion.questionNumber, 3, currentQuestion.parts[3].dataTypeName);
                          }}
                          disabled={currentAnswerList.questions[currentQuestion.questionNumber].answers[0].value === currentQuestion.parts[0].options[2].value ? false : true }
                          ref={numberOfCigaretteEl}
                          min={currentQuestion.parts[3].validateValueMin}
                          max={currentQuestion.parts[3].validateValueMax}
                        />
                      </div>

                      <div className="col-md-2 col-sm-2 text-left">
                        <label className="interview-input-label">{ currentQuestion.parts[3].displayRight}</label>
                      </div>


                    </div>

                  </td>
                </tr>
              </tbody>
            </table>
          </>
          )
      case 6:
        // 「妊娠されていますか？」
        return(
          <>
            {/* スマホ */}
            <div className="d-none">

                  <div className="col-xs-12">
                    <input
                        key={currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId + "-" + 0 + "-" + 1}
                        type="radio"
                        name="optradio_sp"
                        className="display-none interview-radio"
                        id={"radio_sp_" + currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId +  "-" + 0 + "-" + 1}
                        value={[currentQuestion.parts[0].options[0].value, currentQuestion.parts[0].options[0].label]}
                        defaultChecked={currentAnswerList.questions[currentQuestion.questionNumber].answers[0].value === currentQuestion.parts[0].options[0].value }
                        onChange={(e) => {
                          changeRadioButton(e.target.value, currentQuestion.questionNumber, 0, currentQuestion.parts[0].dataTypeName);
                          initializeInput("notPregnant");
                        }}
                      />
                      <label htmlFor={"radio_sp_" + currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId +  "-" + 0 + "-" + 1} className="radio-button">{currentQuestion.parts[0].options[0].label}</label>
                  </div>

                  <div className="col-xs-12">
                    <input
                        key={currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId + "-" + 1 + "-" + 1}
                        type="radio"
                        name="optradio_sp"
                        className="display-none interview-radio"
                        id={"radio_sp_" + currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId +  "-" + 1 + "-" + 1}
                        value={[currentQuestion.parts[0].options[1].value, currentQuestion.parts[0].options[1].label]}
                        defaultChecked={ currentAnswerList.questions[currentQuestion.questionNumber].answers[0].value === currentQuestion.parts[0].options[1].value }
                        onChange={(e) => changeRadioButton(e.target.value, currentQuestion.questionNumber, 0, currentQuestion.parts[0].dataTypeName)}
                    />
                    <label htmlFor={"radio_sp_" + currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId +  "-" + 1 + "-" + 1} className="radio-button">{currentQuestion.parts[0].options[1].label}</label>
                  </div>

                  <div className="col-xs-12">
                    <div className="row interview-input-form">
                      <div className="col-xs-12 text-left">
                        <label className="interview-input-label">{ currentQuestion.parts[1].displayLeft }</label>
                      </div>
                      <div className="col-xs-12">
                        <input
                          key={currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId + "-" + 2}
                          type="date"
                          id={"input_sp_" + currentQuestion.questionNumber + "_" + currentAnswerList.interviewDetailId + "_" + 2}
                          className="form-control"
                          defaultValue={currentAnswerList.questions[currentQuestion.questionNumber].answers[1].value}
                          placeholder={currentQuestion.parts[1].placeholder}
                          disabled={currentAnswerList.questions[currentQuestion.questionNumber].answers[0].value === currentQuestion.parts[0].options[1].value ? false : true }
                          onChange={(e) => changeInput(e.target.value, currentQuestion.questionNumber, 1, currentQuestion.parts[1].dataTypeName)}
                          ref={spExpectedDateEl}
                        />
                      </div>
                    </div>
                  </div>


                  <div className="col-xs-12">
                    <input
                      key={currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId + "-" + 2 + "-" + 1}
                      type="radio"
                      name="optradio_sp"
                      className="display-none interview-radio"
                      id={"radio_sp_" + currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId +  "-" + 2 + "-" + 1}
                      value={[currentQuestion.parts[0].options[2].value, currentQuestion.parts[0].options[2].label]}
                      defaultChecked={currentAnswerList.questions[currentQuestion.questionNumber].answers[1].value === currentQuestion.parts[0].options[2].value }
                      onChange={(e) => {
                        changeRadioButton(e.target.value, currentQuestion.questionNumber, 0, currentQuestion.parts[0].dataTypeName);
                        initializeInput("notPregnant");
                      }}
                    />
                    <label htmlFor={"radio_sp_" + currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId +  "-" + 2 + "-" + 1} className="radio-button">{currentQuestion.parts[0].options[2].label}</label>
                  </div>
            </div>

            {/* スマホ以外 */}
            <table className="d-xs-none col-md-12 col-sm-12 col-xs-12">
              <thead/>
              <tbody>
                <tr>
                  <td className="col-md-6 col-sm-6 col-xs-6">
                    <input
                        key={currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId + "-" + 0 + "-" + 1}
                        type="radio"
                        name="optradio"
                        className="display-none interview-radio"
                        id={"radio_" + currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId +  "-" + 0 + "-" + 1}
                        value={[currentQuestion.parts[0].options[0].value, currentQuestion.parts[0].options[0].label]}
                        defaultChecked={currentAnswerList.questions[currentQuestion.questionNumber].answers[0].value === currentQuestion.parts[0].options[0].value }
                        onChange={(e) => {
                          changeRadioButton(e.target.value, currentQuestion.questionNumber, 0, currentQuestion.parts[0].dataTypeName);
                          initializeInput("notPregnant");
                        }}
                      />
                      <label htmlFor={"radio_" + currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId +  "-" + 0 + "-" + 1} className="radio-button">{currentQuestion.parts[0].options[0].label}</label>
                  </td>
                  <td className="col-md-6 col-sm-6 col-xs-6"/>
                </tr>
                <tr>
                  <td className="col-md-6 col-sm-6 col-xs-6">
                    <input
                        key={currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId + "-" + 1 + "-" + 1}
                        type="radio"
                        name="optradio"
                        className="display-none interview-radio"
                        id={"radio_" + currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId +  "-" + 1 + "-" + 1}
                        value={[currentQuestion.parts[0].options[1].value, currentQuestion.parts[0].options[1].label]}
                        defaultChecked={ currentAnswerList.questions[currentQuestion.questionNumber].answers[0].value === currentQuestion.parts[0].options[1].value }
                        onChange={(e) => changeRadioButton(e.target.value, currentQuestion.questionNumber, 0, currentQuestion.parts[0].dataTypeName)}
                    />
                    <label htmlFor={"radio_" + currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId +  "-" + 1 + "-" + 1} className="radio-button">{currentQuestion.parts[0].options[1].label}</label>
                  </td>
                  <td className="col-md-6 col-sm-6 col-xs-6">
                    <div className="row interview-input-form">
                      <div className="col-md-4 col-sm-12 col-xs-12 text-right">
                        <label className="interview-input-label">{ currentQuestion.parts[1].displayLeft }</label>
                      </div>
                      <div className="col-md-8 col-sm-12 col-xs-12">
                        <input
                          key={currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId + "-" + 2}
                          type="date"
                          id={"input_" + currentQuestion.questionNumber + "_" + currentAnswerList.interviewDetailId + "_" + 2}
                          className="form-control"
                          defaultValue={currentAnswerList.questions[currentQuestion.questionNumber].answers[1].value}
                          placeholder={currentQuestion.parts[1].placeholder}
                          disabled={currentAnswerList.questions[currentQuestion.questionNumber].answers[0].value === currentQuestion.parts[0].options[1].value ? false : true }
                          onChange={(e) => changeInput(e.target.value, currentQuestion.questionNumber, 1, currentQuestion.parts[1].dataTypeName)}
                          ref={expectedDateEl}
                        />
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="col-md-6 col-sm-6 col-xs-6">
                    <input
                      key={currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId + "-" + 2 + "-" + 1}
                      type="radio"
                      name="optradio"
                      className="display-none interview-radio"
                      id={"radio_" + currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId +  "-" + 2 + "-" + 1}
                      value={[currentQuestion.parts[0].options[2].value, currentQuestion.parts[0].options[2].label]}
                      defaultChecked={currentAnswerList.questions[currentQuestion.questionNumber].answers[1].value === currentQuestion.parts[0].options[2].value }
                      onChange={(e) => {
                        changeRadioButton(e.target.value, currentQuestion.questionNumber, 0, currentQuestion.parts[0].dataTypeName);
                        initializeInput("notPregnant");
                      }}
                    />
                    <label htmlFor={"radio_" + currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId +  "-" + 2 + "-" + 1} className="radio-button">{currentQuestion.parts[0].options[2].label}</label>
                  </td>
                  <td className="col-md-6 col-sm-6 col-xs-6"/>
                </tr>
              </tbody>
            </table>
          </>
        )
        case 7:
          // 授乳されていますか？
          return(
            <>
              {/* スマホ */}
              <div className="d-none">

                <div className="col-xs-12">
                  <input
                      key={currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId + "-" + 0 + "-" + 1}
                      type="radio"
                      name="optradio_sp"
                      className="display-none interview-radio"
                      id={"radio_sp_" + currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId +  "-" + 0 + "-" + 1}
                      value={[currentQuestion.parts[0].options[0].value, currentQuestion.parts[0].options[0].label]}
                      defaultChecked={currentAnswerList.questions[currentQuestion.questionNumber].answers[0].value === currentQuestion.parts[0].options[0].value }
                      onChange={(e) => {
                        changeRadioButton(e.target.value, currentQuestion.questionNumber, 0, currentQuestion.parts[0].dataTypeName);
                        initializeInput("notFeeding");
                      }}
                    />
                    <label htmlFor={"radio_sp_" + currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId +  "-" + 0 + "-" + 1} className="radio-button">{currentQuestion.parts[0].options[0].label}</label>
                </div>

                <div className="col-xs-12">
                  <input
                      key={currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId + "-" + 1 + "-" + 1}
                      type="radio"
                      name="optradio_sp"
                      className="display-none interview-radio"
                      id={"radio_sp_" + currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId +  "-" + 1 + "-" + 1}
                      value={[currentQuestion.parts[0].options[1].value, currentQuestion.parts[0].options[1].label]}
                      defaultChecked={ currentAnswerList.questions[currentQuestion.questionNumber].answers[0].value === currentQuestion.parts[0].options[1].value }
                      onChange={(e) => changeRadioButton(e.target.value, currentQuestion.questionNumber, 0, currentQuestion.parts[0].dataTypeName)}
                  />
                  <label htmlFor={"radio_sp_" + currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId +  "-" + 1 + "-" + 1} className="radio-button">{currentQuestion.parts[0].options[1].label}</label>
                </div>
                <div className="col-xs-12">
                  <div className="row interview-input-form">
                    <div className="col-xs-12 text-left">
                      <label className="interview-input-label">{ currentQuestion.parts[1].displayLeft }</label>
                    </div>
                    <div className="col-xs-12">
                      <input
                        key={currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId + "-" + 2}
                        type="number"
                        id={"input_sp_" + currentQuestion.questionNumber + "_" + currentAnswerList.interviewDetailId + "_" + 2}
                        className="form-control"
                        // onChange={(e) => sliceMaxLength(e, 9, "decimal")}
                        defaultValue={currentAnswerList.questions[currentQuestion.questionNumber].answers[1].value}
                        placeholder={currentQuestion.parts[1].placeholder}
                        onBlur={(e) => {
                          !(!e.target.value) ? alertInput(e, 1, "alertmonthOldEl", "number") : "";
                          changeInput(e.target.value, currentQuestion.questionNumber, 1, currentQuestion.parts[1].dataTypeName);
                        }}
                        disabled={currentAnswerList.questions[currentQuestion.questionNumber].answers[0].value === currentQuestion.parts[0].options[1].value ? false : true}
                        ref={spMonthOldEl}
                      />
                    </div>
                    <div className="col-xs-12 text-right">
                      <label className="interview-input-label">{ currentQuestion.parts[1].displayRight }</label>
                    </div>
                  </div>
                </div>
              </div>
            {/* スマホ以外 */}
              <table className="d-xs-none col-md-12 col-sm-12 col-xs-12">
                <thead/>
                <tbody>
                  <tr>
                    <td className="col-md-6 col-sm-6 col-xs-6">
                      <input
                          key={currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId + "-" + 0 + "-" + 1}
                          type="radio"
                          name="optradio"
                          className="display-none interview-radio"
                          id={"radio_" + currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId +  "-" + 0 + "-" + 1}
                          value={[currentQuestion.parts[0].options[0].value, currentQuestion.parts[0].options[0].label]}
                          defaultChecked={currentAnswerList.questions[currentQuestion.questionNumber].answers[0].value === currentQuestion.parts[0].options[0].value }
                          onChange={(e) => {
                            changeRadioButton(e.target.value, currentQuestion.questionNumber, 0, currentQuestion.parts[0].dataTypeName);
                            initializeInput("notFeeding");
                          }}
                        />
                        <label htmlFor={"radio_" + currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId +  "-" + 0 + "-" + 1} className="radio-button">{currentQuestion.parts[0].options[0].label}</label>
                    </td>
                    <td className="col-md-6 col-sm-6 col-xs-6"/>
                  </tr>
                  <tr>
                    <td className="col-md-6 col-sm-6 col-xs-6">
                      <input
                          key={currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId + "-" + 1 + "-" + 1}
                          type="radio"
                          name="optradio"
                          className="display-none interview-radio"
                          id={"radio_" + currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId +  "-" + 1 + "-" + 1}
                          value={[currentQuestion.parts[0].options[1].value, currentQuestion.parts[0].options[1].label]}
                          defaultChecked={ currentAnswerList.questions[currentQuestion.questionNumber].answers[0].value === currentQuestion.parts[0].options[1].value }
                          onChange={(e) => changeRadioButton(e.target.value, currentQuestion.questionNumber, 0, currentQuestion.parts[0].dataTypeName)}
                      />
                      <label htmlFor={"radio_" + currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId +  "-" + 1 + "-" + 1} className="radio-button">{currentQuestion.parts[0].options[1].label}</label>
                    </td>
                    <td className="col-md-6 col-sm-6 col-xs-6">
                      <div className="row interview-input-form">
                        <div className="col-md-5 col-sm-12 col-xs-12 text-right">
                          <label className="interview-input-label">{ currentQuestion.parts[1].displayLeft }</label>
                        </div>
                        <div className="col-md-4 col-sm-12 col-xs-12">
                          <input
                            key={currentQuestion.questionNumber + "-" + currentAnswerList.interviewDetailId + "-" + 2}
                            type="number"
                            id={"input_" + currentQuestion.questionNumber + "_" + currentAnswerList.interviewDetailId + "_" + 2}
                            className="form-control"
                            // onChange={(e) => sliceMaxLength(e, 9, "decimal")}
                            defaultValue={currentAnswerList.questions[currentQuestion.questionNumber].answers[1].value}
                            placeholder={currentQuestion.parts[1].placeholder}
                            disabled={currentAnswerList.questions[currentQuestion.questionNumber].answers[0].value === currentQuestion.parts[0].options[1].value ? false : true}
                            onBlur={(e) => {
                              !(!e.target.value) ? alertInput(e, 1, "alertmonthOldEl", "number") : "";
                              changeInput(e.target.value, currentQuestion.questionNumber, 1, currentQuestion.parts[1].dataTypeName);
                            }}
                            ref={monthOldEl}
                            min={currentQuestion.parts[1].validateValueMin}
                            max={currentQuestion.parts[1].validateValueMax}
                          />
                        </div>
                        <div className="col-md-3 col-sm-12 col-xs-12 text-left">
                          <label className="interview-input-label">{ currentQuestion.parts[1].displayRight }</label>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </>
        )

    }
  }

  // ボタン系
  function viewButton(){
    return(
      <div className="height-10dvh">
        <ul className="pager">
        { currentAnswerList.isComplete === true ? (
          <>
            {
              currentAnswerList.isRegistered === false && (
                <>
                  <div className="col-md-4 col-sm-4 d-xs-none" />
                    <div className="col-md-4 col-sm-12 col-xs-12">
                      <li className="previous">
                        <button className="pager-button" disabled={isAllRequiredAlreadyAnswered} onClick={() => submitInterview()}>登録</button>
                      </li>
                    </div>
                  <div className="col-md-4 col-sm-2 col-xs-2" />
                </>
              )
            }

          </>
        ):(
          <>
            { currentAnswerList.isEditMode === true && (
              <div className="d-none col-xs-12">
                    <li className="previous">
                      <button className="pager-button" disabled={isAnswerRequired ? checkAnswerRequired(): false} onClick={() => setCurrentAnswerList({...currentAnswerList, isComplete: true, isEditMode: false})}>確認画面へ</button>
                    </li>
              </div>
            )}
            {
              currentUser.currentQuestionNumber === 0 ? (
                <>
                  <div className="col-md-2 col-sm-6 col-xs-6"/>
                </>
              ) : (
                <>
                  <div className="col-md-2 col-sm-6 col-xs-6">
                    <li className="previous">
                      <button className="pager-button" onClick={() => changeCurrentQuestionNumber(-1, false)}>戻る</button>
                    </li>
                  </div>
                </>
              )
            }

            { currentAnswerList.isEditMode === true ? (
                <>

                <div className="col-md-3 d-xs-none" />
                <div className="col-md-2 d-xs-none">
                  <li className="previous">
                    <button className="pager-button" disabled={isAnswerRequired ? checkAnswerRequired(): false} onClick={() => changeCurrentQuestionNumber(questionList.length, false)}>確認画面へ</button>
                  </li>
                </div>

                <div className="col-md-3 d-xs-none" />
                </>
              ) : (
                <>
                  <div className="col-md-8 d-xs-none" />
                </>
              )

            }
            <div className="col-md-2 col-sm-6 col-xs-6">
              <li className="next">
                <button className="pager-button" disabled={isAnswerRequired ? checkAnswerRequired(): false} onClick={() => changeCurrentQuestionNumber(1, false)}>次へ</button>
              </li>
            </div>
          </>
        )}
      </ul>
    </div>
    )
  }

  return(
    <LoadingOverlay
      active={isLoading}
      spinner
      text='Loading...'
    >
    <div className="row row-height-flex full margin-all-0 apple-system-font">
      <div className="panel panel-defalut col-md-3 col-sm-3 d-xs-none padding-left-0 padding-right-0 border-none margin-all-0">
        <div className="panel-body bg-green height-100">

          {/* 名前エリア */}
          <div className="text-center side-name-area">
            <h4>{currentUser.patientName} 様</h4>
            <br/>
          </div>

          {/* アイコンエリア */}
          <div className="text-center side-icon-area">
            <img src={icon} className="img-circle img-responsive bg-lightgreen side-icon-img" alt="アイコン"></img>
            <br/>
          </div>

          {/* コメントエリア */}
          { 
            props.is_clinic ? (
              <div className="text-center side-comment-area">
                ご来院ありがとうございます。<br/>
                安全な薬物治療を行うために、次の質問にご回答ください。
                <br/>
              </div>
            ):(
              <div className="text-center side-comment-area">
                ご来局ありがとうございます。<br/>
                安全な薬物治療を行うために、次の質問にご回答ください。
                <br/>
              </div>
            )
          }

          {/* ページエリア */}
          <div className="text-center side-page-area">
            {
              currentCategoryList.categories.map((category) => {
                return(
                  <>
                    {
                      category.partGroupId === currentQuestion.partGroupId ? (
                        <label className="side-menu-active">{category.categoryName}</label>
                      ) :
                      (
                        <label className="side-menu">{category.categoryName}</label>
                      )

                    }
                  </>
                )
              })
            }
          </div>

        </div>
      </div>
          <div className="panel panel-defalut col-md-9 col-sm-12 col-xs-12 padding-left-0 padding-right-0 border-none margin-all-0">
            <div className="panel-body bg-subscreen height-100dvh">
            {viewButton()}
              {/* タブメニュー */}
              <div className="d-xs-none">
                <ul className="nav nav-tabs nav-justified height-10">
                  { users.map((user) =>
                    user.interviewDetailId == currentUserId ?
                      (
                      <li className="active bg-subscreen col-md-2" key={user.interviewDetailId}>
                        <a data-testid={"patient_" + user.interviewDetailId} className="patient-tab-active" onClick={() => setCurrentUserId(user.interviewDetailId)}>
                          {currentAnswerList.isComplete === true ? (
                            <>
                              { currentUser.patientName}
                            </>
                          ):(
                            <>
                              { currentUser.patientName + "(" + (parseInt(currentUser.currentQuestionNumber) + 1) + "/" + (questionList.length) + ")"}
                            </>
                            )}

                        </a>
                      </li>
                      ) : (

                      <li className="col-md-2" key={user.interviewDetailId}>
                        <a data-testid={"patient_" + user.interviewDetailId} className="patient-tab" onClick={() => setCurrentUserId(user.interviewDetailId)}>
                        {findComplete(user.interviewDetailId) === true ? (
                          <>
                            { user.patientName }
                          </>
                        ):(
                          <>
                            {  user.patientName + "(" + (parseInt(user.currentQuestionNumber) + 1) + "/" + findPatient(user.interviewDetailId)+ ")" }
                          </>
                        )}

                        </a>
                      </li>
                      )
                  )}
                </ul>
              </div>
              {/* スマホ用タブメニュー */}
              {
                users.length > 1 && (
                  <div className="d-none col-xs-12 height-8dvh">
                    <select
                      className="form-control interview-input-label"
                      id={"user_list"}
                      onChange={(e) => setCurrentUserId(Number(e.target.value))}
                      value={String(currentUserId)}
                    >
                      {users.map((user) => {
                        return(
                          <option value={user.interviewDetailId} key={"user_" + user.interviewDetailId}>
                            {user.patientName}
                          </option>
                        )
                      })}
                    </select>
                  </div>
                )
              }

              <div className="panel panel-defalut col-md-12 col-sm-12 col-xs-12 question-area bg-subscreen scroll" id="contents_area">
                <div className="panel-body">

                  {
                    currentAnswerList.isComplete === true ? (
                      <>
                        {
                          currentAnswerList.isRegistered === true ? (
                            <>
                              <div className="height-90">
                                  <div className="text-center col-md-12 col-sm-12 col-xs-12">
                                    <img src={thankyouImg} className="human-img" alt="アイコン"></img>
                                  </div>
                                  {props.is_lend === true ? (
                                    <>
                                      <div className="col-md-12 col-sm-12 col-xs-12">
                                        <h3 className="text-center question-title ">ご入力ありがとうございました。</h3>
                                      </div>
                                      <div className="col-md-12 col-sm-12 col-xs-12">
                                        <h3 className="text-center question-title ">この画面のまま、スタッフにご返却ください。</h3>
                                      </div>
                                      { props.add_line_qr_tag && (
                                        <>
                                          <br/>
                                          <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="thumbnail">
                                              <a>
                                              <label className="interview-font-color">LINE友だち追加はこちらから</label>
                                                <div className="caption text-center">
                                                  {ReactHtmlParser(props.add_line_qr_tag)}
                                                </div>
                                              </a>
                                            </div>
                                          </div>
                                        </>
                                      )}
                                      <div className="col-md-12 col-sm-12 col-xs-12">
                                        <h3 className="text-center question-title "></h3>
                                      </div>
                                    </>
                                  ):(
                                    <>
                                      <div className="col-md-12 col-sm-12 col-xs-12">
                                        <br/>
                                        <h3 className="text-center question-title ">データ送信完了</h3>
                                      </div>
                                      <div className="col-md-12 col-sm-12 col-xs-12">
                                        <h3 className="text-center question-title ">ご入力ありがとうございました</h3>
                                        <br/>
                                      </div>
                                      {
                                        props.add_line_button_tag ? (
                                          <>
                                          <div className="col-md-1 d-xs-none"/>
                                          {
                                            !props.is_clinic && (
                                              <div className="col-md-5 col-sm-12 col-xs-12">
                                                <div className="thumbnail">
                                                  <a href="https://note.com/yakkyoku_guide/">
                                                    <label className="interview-font-color">薬局活用ガイド</label>
                                                    <img src={yakkyoku_guide_thumb}/>
                                                    <div className="caption">
                                                      <p>賢く薬局を活用するための情報をお届けしていきます。薬を安全に使うために、そして健康づくりのために、あなたにとって「良い薬局」を見つける役に立ちますように。</p>
                                                    </div>
                                                  </a>
                                                </div>
                                              </div>
                                            )
                                          }

                                          <div className="col-md-5 col-sm-12 col-xs-12">
                                            <div className="thumbnail">
                                                <label className="interview-font-color">LINE友だち追加はこちらから</label>
                                                <div className="caption text-center">
                                                  {ReactHtmlParser(props.add_line_button_tag)}
                                                </div>
                                            </div>
                                          </div>
                                          <div className="col-md-1 d-xs-none"/>
                                          </>
                                        ):(
                                        !props.is_clinic && (
                                          <>
                                            <div className="col-md-3 d-xs-none"/>
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                              <div className="thumbnail">
                                                <a href="https://note.com/yakkyoku_guide/">
                                                  <label className="interview-font-color">薬局活用ガイド</label>
                                                  <img src={yakkyoku_guide_thumb}/>
                                                  <div className="caption">
                                                    <p>賢く薬局を活用するための情報をお届けしていきます。薬を安全に使うために、そして健康づくりのために、あなたにとって「良い薬局」を見つける役に立ちますように。</p>
                                                  </div>
                                                </a>
                                              </div>
                                            </div>
                                            <div className="col-md-3 d-xs-none"/>
                                          </>
                                        )
                                        )

                                      }


                                    </>
                                  )
                                }
                              </div>
                            </>
                          ):(
                            <>
                            <div className="height-10">
                              <h3 className="question-title">登録内容の確認</h3>
                              <hr className="border-top-5"/>
                            </div>
                            <div className="height-90">
                              <div className="interview-font-color">
                                回答内容をご確認いただき、変更点がある場合は項目名をクリックしてください。
                              </div>
                              {currentCategoryList.categories.map((category)=>{
                                return(
                                  <div className="panel panel-default">
                                    <table className="table table-bordered table-noborder">
                                      <thead className="interview-table-head">
                                        <tr>
                                          <th colSpan={2}>{category.categoryName}</th>
                                        </tr>
                                      </thead>
                                      <tbody className="interview-table">
                                        { questionList.map((question) => {
                                          return(
                                            <>
                                              {
                                                question.partGroupId === category.partGroupId && (
                                                  <>
                                                    {currentAnswerList.questions[question.questionNumber].answers.map((answer, i) => {
                                                      return (
                                                        i === 0 ? (
                                                          <>
                                                            <tr>
                                                              <td className="col-md-3 col-sm-3 col-xs-3" rowSpan={currentAnswerList.questions[question.questionNumber].answers.length}>
                                                                <a
                                                                  href="#"
                                                                  className="interview-font-color"
                                                                  onClick={()=> changeCurrentQuestionNumber(question.questionNumber ,true)}
                                                                >
                                                                <u>{question.shortTitle}</u>
                                                                </a>
                                                              </td>
                                                              <td className="col-md-8 col-sm-8 col-xs-8">
                                                                {
                                                                  answer.imgValue.length == 0 ? (
                                                                    answer.isAnswerRequired ? (
                                                                    <>
                                                                      <div className="col-md-1 col-sm-12 col-xs-12">
                                                                        <span className="label label-danger">必須</span>
                                                                      </div>
                                                                      <div className="col-md-11 col-sm-12 col-xs-12">
                                                                      {answer.label}
                                                                      </div>
                                                                    </>
                                                                    ) : (
                                                                      <div className="col-md-12 col-sm-12 col-xs-12">
                                                                        {answer.label}
                                                                      </div>
                                                                    )
                                                                  ) : (
                                                                    answer.isAnswerRequired ? (
                                                                      <>
                                                                        <div className="col-md-1 col-sm-12 col-xs-12">
                                                                          <span className="label label-danger">必須</span>
                                                                        </div>
                                                                        {
                                                                          answer.imgValue.map((img_value) =>{
                                                                            return(
                                                                              <img className="col-md-6 col-sm-12 col-xs-12 interview-img-thumbnail" src={img_value.imgPath}/>
                                                                            )
                                                                          })
                                                                        }
                                                                      </>
                                                                      ) : (
                                                                        answer.imgValue.map((img_value) =>{
                                                                          return(
                                                                            <img className="col-md-6 col-sm-12 col-xs-12 interview-img-thumbnail" src={img_value.imgPath}/>
                                                                          )
                                                                        })
                                                                    )

                                                                  )
                                                                }
                                                              </td>
                                                            </tr>
                                                          </>
                                                        ):(
                                                          <>
                                                            <tr>
                                                              <td className="col-md-8 col-sm-8 col-xs-8">
                                                                  {
                                                                    answer.imgValue.length == 0 ? (
                                                                      answer.isAnswerRequired ? (
                                                                        <>
                                                                          <div className="col-md-1 col-sm-12 col-xs-12">
                                                                            <span className="label label-danger">必須</span>
                                                                          </div>
                                                                          <div className="col-md-11 col-sm-12 col-xs-12">
                                                                          {answer.label}
                                                                          </div>
                                                                        </>
                                                                      ) : (
                                                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                                                          {answer.label}
                                                                        </div>
                                                                      )
                                                                    ) : (
                                                                      answer.isAnswerRequired ? (
                                                                        <>
                                                                          <div className="col-md-1 col-sm-12 col-xs-12">
                                                                            <span className="label label-danger">必須</span>
                                                                          </div>
                                                                          {
                                                                            answer.imgValue.map((img_value) =>{
                                                                              return(
                                                                                <img className="col-md-6 col-sm-12 col-xs-12 interview-img-thumbnail " src={img_value.imgPath}/>
                                                                              )
                                                                            })
                                                                          }
                                                                        </>
                                                                        ) : (
                                                                          answer.imgValue.map((img_value) =>{
                                                                            return(
                                                                              <img className="col-md-6 col-sm-12 col-xs-12 interview-img-thumbnail " src={img_value.imgPath}/>
                                                                            )
                                                                          })
                                                                        )
                                                                    )
                                                                  }
                                                                </td>
                                                            </tr>
                                                          </>
                                                        )
                                                      )
                                                    })}
                                                  </>
                                                )
                                              }

                                            </>
                                          )
                                        })}
                                      </tbody>
                                    </table>
                                  </div>
                                )
                              })}
                        </div>
                            </>
                          )
                        }

                      </>
                    ) : (
                        <>
                        　<div className="">
                            <h3 className="question-title">Q.{currentQuestion.title}</h3>
                            <hr className="border-top-5"/>
                          </div>
                          <div className="">
                            { currentQuestion.parts.map((part, idx) => {
                              return(
                                currentQuestion.partKbn === 2 ? (
                                  // 通常パーツの場合
                                  <>
                                    {partView(part, idx)}
                                  </>
                                ) : (
                                  <>
                                    {
                                      (idx === 0) && (
                                        <>
                                          {specialPartView()}
                                        </>
                                      )
                                    }

                                  </>
                                )
                              )
                            })}
                          </div>
                        </>
                    )
                  }
                </div>
              </div>
              <div className="height-2dvh bg-subscreen" />
            </div>

          </div>

    </div>
    </LoadingOverlay>
  )
}

export default Index
